export const environment = {
  production: false,
  api: {
    url: 'https://telemann-api.server018.com/api',
    allowedUrl: 'telemann-api.server018.com',
  },
  gallery: {
    apiKey: '6A351E2C-C50B-4DCA-8102-C451576002CA'
  },
  cdn: {
    url: 'https://telemann-cdn.server018.com'
  },
  website: {
    url: 'https://telemann.server018.com'
  },
  docs: {
    url: 'https://docs.telemann.de'
  }
};
